import { useRef, useState } from "react";

import { Gantt, Toolbar, ContextMenu } from "wx-react-gantt";
import "wx-react-gantt/dist/gantt.css";
import "./App.css";

import { getData } from "./data.js";

const data = getData();
export let api;


function isDayOff(date) {
  const d = date.getDay();
  return d === 0 || d === 6;
}
function isHourOff(date) {
  const h = date.getHours();
  return h < 8 || h === 12 || h > 17;
}
function highlightTime(d, u) {
  if (u === "day" && isDayOff(d)) return "wx-weekend";
  if (u === "hour" && (isDayOff(d) || isHourOff(d))) return "wx-weekend";
  return "";
}

export default function App() {
  const apiRef = useRef(null);
  const menuHandler = useRef(null);
  const [ ready, setReady ] = useState(false);

  return (
    <div style={ { position:"relative" } } data-wx-portal-root="true">
      <Toolbar api={apiRef.current} ready={ready} />
      <div style={{ "borderTop": "1px solid #eee" }} onContextMenu={ev => menuHandler.current(ev)}>
        <Gantt
          api={apiRef}
          init={() => setReady(true)}
          highlightTime={highlightTime}
          zoom={true}
          scales={data.scales}
          tasks={data.tasks}
          links={data.links}
        />
      </div>
    	<ContextMenu api={apiRef.current} init={v => menuHandler.current = v} ready={ready}></ContextMenu>
  </div>
  );
}
